import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-411f823c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal-dialog modal-sm modal-dialog-centered",
  role: "document"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-body text-center" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin" })
    ])
  ])
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingModal',
  setup(__props) {

const store = useStore();
const hasBlockingRequests = computed(() => store.getters['app/hasBlockingRequests']);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade modal-full", {show: hasBlockingRequests.value}]),
    id: "loading-modal",
    "data-keyboard": "false",
    role: "dialog",
    "aria-hidden": "true"
  }, _hoisted_2, 2))
}
}

})